import {
  GET_USER_DATA,
  ADD_MEDIAS_DATA,
  UPDATE_MEDIAS_PAGINATION,
  SET_STORY,
  MEDIAS_DATA_ERROR,
  IS_EMPTY_ACCOUNT,
} from '../../constants';
import { getStories } from '../api/instagramApi';
import {
  getInstagramMediasData,
  getUserInfo,
} from './instagramUserAndMediasService';
import { GALLERY_TYPES } from '../../constants/proGalleryConstants';
import { CLICKING_ON_AVATAR_OPTIONS } from '../../constants/settingsConstants';
import { getMediasLinksCount } from './linksService';
import { getAllHashtagsItems } from './hashtagService';
import { getCountParam } from '../more/utils';
import { calculateGalleryHeight } from '../gallery/galleryHeight';
import sendBIMediaErrors from '../more/sendBIMediaErrors';
import store from '../../store';

/**
 * Get data of user and medias from instagram (templates / connectedUser)
 * @param {boolean} isTemplate - if this account is template
 */
export const getInstagramData = (isTemplate) => async (dispatch) => {
  const { isBusinessApp } = store.getState().appReducer;
  if (isBusinessApp) {
    // dispatch(getStory(isTemplate));
    dispatch(_getHashtag());
  }

  getUserInfo().then((userData) => {
    dispatch({
      type: GET_USER_DATA,
      payload: userData,
    });
  });

  const count = getCountParam(GALLERY_TYPES.FEED);

  dispatch(_getMedias(isTemplate, '', count));
};

/**
 * Get story on instagram account
 */
export const getStory = (isTemplate) => (dispatch) => {
  const { clickingOnProfilePicture } = store.getState().settingsReducer;
  if (clickingOnProfilePicture === CLICKING_ON_AVATAR_OPTIONS.OPEN_STORY) {
    getStories(isTemplate).then((stories) => {
      dispatch({
        type: SET_STORY,
        stories,
      });
    });
  }
};

/**
 * Get medias of instgarm (templates / connectedUser)
 * @param {*} isTemplate - if app is template
 * @param {*} after - if has pagination, cursor after
 * @param {*} count - count of medias
 */
const _getMedias = (isTemplate, after, count) => (dispatch) => {
  return getInstagramMediasData(after, count)
    .then(({ medias, pagination }) => {
      if (medias.length) {
        dispatch({
          type: ADD_MEDIAS_DATA,
          payload: medias,
        });

        dispatch({
          type: UPDATE_MEDIAS_PAGINATION,
          payload: pagination,
        });

        dispatch(calculateGalleryHeight(GALLERY_TYPES.FEED));
        dispatch(getMediasLinksCount(medias, isTemplate));
      } else {
        dispatch({
          type: IS_EMPTY_ACCOUNT,
          // payload: buildError(ERRORS.NO_POSTS, 'Account has no posts'),
        });
      }

      return { medias, pagination };
    })
    .catch((error) => {
      sendBIMediaErrors(error);
      dispatch({
        type: MEDIAS_DATA_ERROR,
        payload: error,
      });
    });
};

/**
 * Get hashtag when the user is connected.
 */
export const _getHashtag = () => async (dispatch) => {
  const { hashtags, isMobile, viewMode } = store.getState().appReducer;
  const {
    m_isDisplayHashtagsFeed,
    isDisplayHashtagsFeed,
  } = store.getState().settingsReducer;

  const isDisplayHashtag = isMobile
    ? m_isDisplayHashtagsFeed
    : isDisplayHashtagsFeed;

  if (isDisplayHashtag || viewMode === 'editor') {
    const count = getCountParam(GALLERY_TYPES.HASHTAG);
    dispatch(getAllHashtagsItems(hashtags, count));
  }
};
